module.exports = __webpack_public_path__ + "static/media/yuuki-asuna.d8eceea9.png";